import { render, staticRenderFns } from "./tord_appeals.vue?vue&type=template&id=37f8a9e6&scoped=true&"
import script from "./tord_appeals.vue?vue&type=script&lang=js&"
export * from "./tord_appeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8a9e6",
  null
  
)

export default component.exports